import { conv } from '@/util'
import { wgs2gcj,wgs2gcjBatch,gcj2wgs } from '@/util/map/proj'
import { getPositionByCode } from '@/components/vue-sl/city-select'
import Event from '@/util/proto/event'
import request,{ getStaticPath } from '@/util/request'


//缓存全国车辆数据
var carDatasCache
const whenCached = (options = {}, filter) => {
  if( carDatasCache ){
    return Promise.resolve(carDatasCache)
  }else if(whenCached.task){
    return whenCached.task
  }else{
    let c = getPositionByCode('86')
    let params = {radius:3000000,lat:c[1],lng:c[0],...options}

    try{
      whenCached.task = request.screenCarMap(params).then( resp => {
        if(resp.data){
          resp.data = resp.data.filter(filter)
        }
        carDatasCache = resp
        whenCached.task = null
        return Promise.resolve(carDatasCache)
      })
    }catch(e){
      whenCached.task = request.screenCarMap(params).then( resp => {
        if(resp.data){
          resp.data = resp.data.filter(filter)
        }
        carDatasCache = resp
        whenCached.task = null
        return Promise.resolve(carDatasCache)
      })
    }
    
    return whenCached.task
  }
}

const brandsMap = {}
export const getBrands = () => {
  if( Object.keys(brandsMap).length > 0 ){
    return Promise.resolve(brandsMap)
  }else if(getBrands.task){
    return getBrands.task
  }else{
    try{
      getBrands.task = request.brands(0).then( resp => {
        if (resp.code == 0) {
          resp.data.forEach(i => {
            i.logo = getStaticPath(i.brandLogo)
            brandsMap[i.id] = i
          })
        }
        getBrands.task = null

        return Promise.resolve(brandsMap)
      })
      return getBrands.task
    }catch(e){
      return Promise.resolve(brandsMap)
    }
    
  }
}


class DataManager extends Event{
  constructor(map, acl = () => true) {
    super()
    this.carsHash = {}
    this.data = []
    this.acl = acl
    this.map = map
    this.stateStats = []
  }

  async fetch(params = {} , types) {
    this.ready = false

    let acl = this.acl

    //defaultRadius
    this.loading = true

    let stateStats = types.reduce((t,c,idx) => (t[c.value] = {...c , count:0 , visible:true} , t), [])

    let resp = await whenCached(params,this.acl)

    let brands = await getBrands()


    if (!resp.code) {
      let data = []

      conv(resp.data || [],{}).filter(this.acl).forEach(i => {

        if(i.lng && i.lat){
          let c = wgs2gcj(i.lng , i.lat)
          let ret = {
            id: i.id,
            carNo: i.carNo,
            lng: c[0],
            lat: c[1],
            mixState: i.mixState,
            label: i.license || `No.${i.carNo}`,
            license:i.license,
            tags:[i.carNo , (i.license || '').replace(/[^a-z0-9]/ig, '').toUpperCase() , (i.license || '').replace(/[^0-9]/ig, '').toUpperCase()],

            lnglat:[...c],
            logo:brands[i.brandId]?.logo,
            companyName:i.shortName || i.companyName || ''
          }
          if( stateStats[i.mixState] ) {
            // TODO mock 2021-12-06
            stateStats[i.mixState].count+=1
          }

          data.push( ret )
        }
        this.carsHash[i.carNo] = i
        
        this.stateStats = stateStats
      })


      return { data , stateStats }
    }
    
  }

  async watch(params = {}){

    if(this.watchWorking) return

    this.watchWorking = true

    const BLACKLIST = this.acl

    let carsHash = this.carsHash
    let def = this.map.getBounds()
    let ne = def.getNorthEast()
    let c = def.getCenter()
    let r = c.distance(ne) * 1.1
    let { displayType } = this
    let convPostion = gcj2wgs(c.getLng(),c.getLat())
    params = { ...params , radius:r , lat:convPostion[1], lng:convPostion[0]}
    
    let brands = await getBrands()

    let resp = await request.screenCarMapLive(params)

    this.watchWorking = false

    let data = (resp.data || [])
      .filter(this.acl)
      .map(i => {
        let c = wgs2gcj(i.lng, i.lat)
        i.lng = c[0]
        i.lat = c[1]

        if (i.history) {
          wgs2gcjBatch(i.history)
        }
        let ret = {
          ...i,
          state:i.mixState,
          id:i.carNo,
          label:this.carsHash[i.carNo]?.licenseNo || ('No.'+i.carNo),
          visible:true,
          companyName:this.carsHash[i.carNo]?.companyName || i.shortName || i.companyName || '',
          logo:this.carsHash[i.carNo]?.logo || brands[i.brandId]?.logo
        }

        if(carsHash[i.carNo]){
          carsHash[i.carNo].lat = i.lat
          carsHash[i.carNo].lng = i.lng
          carsHash[i.carNo].lnglat = [i.lng,i.lat]
          carsHash[i.carNo].mixState = i.mixState
        }else{
          carsHash[i.carNo] = ret
        }


        if( ret.state ){
          ret.visible = this.stateStats[i.mixState].visible
        }
        return ret
      })

    this.trigger('patch' , data)

    this.watchHandler = window.setTimeout(() => {
      this.watch(params)
    },5000)

  }

  unwatch(){
    if( this.watchHandler ){
      window.clearTimeout(this.watchHandler)
      this.watchHandler = null
    }
  }



}

export default DataManager